import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useWhistleblowerPortalUrl } from 'pages/whistleblowing/utilities'
import Modal from 'modals/dialog'
import Paragraph from 'components/typography/paragraph'
import { InlineMessage } from 'components/message'
import Actions from 'components/form/actions'
import { Button } from 'components/button'
import Copyable from 'components/copyable'

const WhistleblowingSetUp = ({ onDone }) => {
    const { formatMessage } = useIntl()
    const portalUrl = useWhistleblowerPortalUrl({
        withLocale: false,
        withTheme: false
    })

    return (
        <>
            <Modal.Header
                heading={formatMessage({
                    id: 'whistleblowing_settings_share_portal_heading',
                    defaultMessage: 'Share the whistleblower portal'
                })}
                showDismiss={false} />
            <Modal.Body>
                <Paragraph>
                    <FormattedMessage
                        id="whistleblowing_settings_share_portal_description"
                        defaultMessage="Huma has established an external portal for your organization, where both employees and external parties can report incidents and follow updates to their ongoing cases. Share this page with anyone who should be able to report incidents." />
                </Paragraph>
                <InlineMessage
                    type="idea"
                    className="spacious"
                    message={formatMessage({
                        id: 'whistleblowing_settings_share_portal_website_link_tip',
                        defaultMessage: 'Consider making the whistleblower portal link easily accessible at your company’s website.'
                    })} />
                <Copyable
                    text={portalUrl}
                    displayText={portalUrl.replace('https://', '')}
                    className="code"
                    truncate />
            </Modal.Body>
            <Modal.Footer>
                <Actions>
                    <Button
                        onClick={onDone}
                        className="constructive">
                        <FormattedMessage
                            id="action_done"
                            defaultMessage="Done" />
                    </Button>
                </Actions>
            </Modal.Footer>
        </>
    )
}

export default WhistleblowingSetUp